import { ReactNode, useEffect, useState } from "react";
import "./styles.css";
import { Outlet, useLocation } from "react-router-dom";
import { ReactComponent as LogoPastejo } from "../../../assets/svg/logo/logoPastejoV2.svg";
import { LanguageSelector } from "../../../components/LanguageSelector";
import { useTranslation } from "react-i18next";

type SessionTemplateProps = {
  children?: ReactNode | Array<ReactNode>;
};

export function SessionTemplate({ children }: SessionTemplateProps) {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  const [headerOnTop, setHeaderOnTop] = useState<boolean>(false);

  function handleTitlepage(path: string) {
    switch (path) {
      case "/entrar":
        return t("session.login");
      case "/cadastro":
        return "Cadastro";
      case "/bemvindo":
        return "Bem Vindo";
      default:
        "";
    }
  }

  useEffect(() => {
    document.title = `Pastejo | ${handleTitlepage(pathname)}`;
  }, [pathname, i18n.language]);

  useEffect(() => {
    function handleScroll(event: Event) {
      const target = event.target as Element;
      if (target.scrollTop > 10) setHeaderOnTop(true);
      else setHeaderOnTop(false);
    }

    document
      .querySelector(".session-template__container")
      ?.addEventListener("scroll", handleScroll);

    return () =>
      document
        .querySelector(".session-template__container")
        ?.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="session-template__container">
      <header className={`${headerOnTop ? "onTop" : ""}`}>
        <div className="session-template__header--logo">
          <LogoPastejo />
        </div>
        <LanguageSelector compact className="session-template__language-selector" />
      </header>
      <main>{children ? <>{children}</> : <Outlet />}</main>
    </div>
  );
}
